import { makeStyles } from '@material-ui/core/styles';
import { colors } from '@loggi/mar';

export const useStyles = makeStyles({
  tableHead: {
    backgroundColor: colors.smoke[100]
  },
  actionMessageConflict: {
    color: colors.red[700]
  },
  actionMessageAdd: {
    color: colors.green[700]
  },
  linkConflict: {
    color: colors.red[700],
    fontWeight: 'bold'
  },
  conflictTableBody: {
    backgroundColor: colors.root[0],
    borderBottom: 'none',
    '&:nth-child(odd)': {
      backgroundColor: colors.smoke[50]
    }
  }
});

export default {
  useStyles
};
